module.exports = __webpack_public_path__ + "img/iugu-icon.21f828a6.svg";